export function SmileIcon({ ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      id='Icon_feather-smile'
      data-name='Icon feather-smile'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      {...props}
    >
      <path
        id='Union_3'
        data-name='Union 3'
        d='M2.343,13.657A8,8,0,1,1,13.657,2.343,8,8,0,1,1,2.343,13.657ZM3.05,3.05a7,7,0,0,0,9.9,9.9,7,7,0,0,0-9.9-9.9ZM4.6,9.8a.5.5,0,0,1,.8-.6A3.576,3.576,0,0,0,8,10.5a3.577,3.577,0,0,0,2.6-1.3.5.5,0,1,1,.8.6A4.533,4.533,0,0,1,8,11.5,4.535,4.535,0,0,1,4.6,9.8Zm5.65-3.55a.5.5,0,0,1,0-1h.007a.5.5,0,0,1,0,1Zm-4.5,0a.5.5,0,1,1,0-1h.007a.5.5,0,0,1,0,1Z'
        fill='currentColor'
      />
    </svg>
  )
}
